import CM from '@emersya/mpa-components-manager-lib';

export interface IStandingComponentConfiguration extends CM.Component.IConfiguration {
};

export class StandingComponent extends CM.Component<
	StandingComponent,
	IStandingComponentConfiguration
>
{

};
export namespace NS {
	export const Component = StandingComponent;
	export type Component = StandingComponent;
	export type Configuration = IStandingComponentConfiguration;
}
// import manifestXMLSource from './.xml';

CM.declare({
	id :   'standing',
	type : StandingComponent,
	// manifest : manifestXMLSource
});
